<web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>

<div class="panel-options-body">
    <div class="form form-horizontal"></div>
</div>
